export const GOOGLE_MAPS_LIBRARIES = ["places", "directions", "geometry"];
